import { QuizManager } from '../modules/quiz-manager';

const getInitialPrelander = version => (version ? version.split('.')[0] : undefined);

const getCurrentPrelander = () => {
    const { version } = new QuizManager([]).getResults();

    return getInitialPrelander(version);
};

export {
    getInitialPrelander,
    getCurrentPrelander
};
